import type { SellableModuleDto } from "../data";

const createdAt = (index: number): string =>
  `2026-01-${String((index % 28) + 1).padStart(2, "0")}T09:00:00.000Z`;

/**
 * 28 seeded modules — comfortably over the 25+ the brief asks for, so paging
 * across multiple pages and every filter/sort combination has real rows to
 * exercise, not a set small enough to fit on one page and mask a handler that
 * ignores `page`.
 */
export const catalogSellableModules: readonly SellableModuleDto[] = Array.from(
  { length: 28 },
  (_, offset) => {
    const index = offset + 1;

    return {
      id: `module-${String(index).padStart(2, "0")}`,
      slug: `module-${String(index).padStart(2, "0")}`,
      nameEn: `Module ${String(index).padStart(2, "0")}`,
      nameAr: `وحدة ${String(index).padStart(2, "0")}`,
      descriptionEn: `Sellable module ${String(index).padStart(2, "0")}.`,
      descriptionAr: `الوحدة القابلة للبيع رقم ${String(index).padStart(2, "0")}.`,
      purchasingPrice: 100 + index * 10,
      // Every fourth module has no default resale price set yet.
      sellingPrice: index % 4 === 0 ? null : 150 + index * 12,
      createdAt: createdAt(index),
      updatedAt: createdAt(index + 1),
    };
  },
);

/**
 * `GET /modules/capacity` for the modules above: module 07 is full, 08 has
 * no ceiling, 28 has no capacity line at all, the rest have room.
 */
export const catalogModuleCapacities = catalogSellableModules
  .filter((module) => module.id !== "module-28")
  .map((module, offset) => {
    const index = offset + 1;
    return index === 7
      ? { moduleId: module.id, quantity: 5, used: 5, remaining: 0, overage: 0 }
      : index === 8
        ? {
            moduleId: module.id,
            quantity: null,
            used: 3,
            remaining: 0,
            overage: 0,
          }
        : {
            moduleId: module.id,
            quantity: 10 + index,
            used: index,
            remaining: 10,
            overage: 0,
          };
  });
